import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  currentPlanKey,
  paymentMethodsKey,
  paymentDetails,
  deletePaymentInformationRoute,
} from '@features/payments';
import axiosInstance from '@server/axiosInstance';

type useDeletePaymentMethodProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useDeletePaymentMethod = ({
  setErrorText = () => { },
  onSuccess = () => { },
}: useDeletePaymentMethodProps) => {
  const client = useQueryClient();

  const { mutate: deletePaymentMethod, isLoading: isDeletePaymentMethod } =
    useMutation({
      mutationFn: (variables: { payment_id: string }) =>
        axiosInstance
          .post(deletePaymentInformationRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          onSuccess();
          client.invalidateQueries([currentPlanKey]);
          client.invalidateQueries([paymentMethodsKey]);
          client.invalidateQueries([paymentDetails]);
        }
      },
      onError: () => setErrorText(errorMessage),
    });

  return {
    deletePaymentMethod,
    isDeletePaymentMethod,
  };
};
